import { useEffect, useState } from "react";
import { getEyeAbleDomain } from "./EyeAbleScript/getEyeAbleDomain";
import styles from "./PreHeader.module.css";

type PreHeaderProps = {
  isInverted?: boolean;
  isFullWidth?: boolean;
};

const PreHeader = ({
  isInverted = false,
  isFullWidth = false,
}: PreHeaderProps) => {
  // eyeAble.js loads asynchronously, so poll until EyeAbleAPI becomes available
  const [isEyeAbleReady, setIsEyeAbleReady] = useState(getEyeAbleDomain());

  useEffect(() => {
    if (isEyeAbleReady) return;

    const intervalId = window.setInterval(() => {
      if (getEyeAbleDomain()) {
        setIsEyeAbleReady(true);
        window.clearInterval(intervalId);
      }
    }, 300);

    return () => window.clearInterval(intervalId);
  }, [isEyeAbleReady]);

  if (!isEyeAbleReady) return null;

  const navClassName = isInverted
    ? `${styles.base} ${styles.isInverted}`
    : styles.base;

  const containerClassName = isInverted
    ? `${styles.fullWidthContainer} ${styles.isInverted}`
    : styles.fullWidthContainer;

  const content = (
    <nav className={navClassName} aria-label="Sekundäre Navigationsleiste">
      <button
        type="button"
        className={styles.item}
        onClick={() => window.EyeAbleAPI?.toggleToolbar?.()}
      >
        {/* blockt den nativen EyeAble Trigger */}
        <span
          className="eyeAble_customToolOpenerClass"
          style={{ display: "none" }}
        />

        <img
          src="../Icons/VisualHelp.png"
          alt=""
          className={styles.icon}
          aria-hidden="true"
        />

        <span className={styles.text}>Visuelle Hilfe</span>
      </button>
    </nav>
  );

  return isFullWidth ? (
    <div className={containerClassName}>{content}</div>
  ) : (
    content
  );
};

export default PreHeader;
